import DelayHelper from 'utils/timers';
import { on, off } from 'delegated-events';

enum SelectorTypes {
	STRING,
	ELEMENT,
	NODE_LIST
}
export type SelectorElement = string | Element | Document | Window | NodeListOf<Element>;

export class EventListener {
	public selectorType: SelectorTypes = null;
	public id: number;

	constructor(
		public type: string,
		public action: EventListenerOrEventListenerObject | Function,
		public selector: SelectorElement = null,
		public tag: String = null
	) {
		//If an Event on an actual element like a click then
		if (this.selector !== null) {
			this.selectorType = this._getSelectorType(this.selector);
			this._on();
		}

		if (this.action) {
			this.action.toString();
		}
	}

	public destroy(): void {
		if (this.selectorType !== null) {
			this._off();
		}

		this.type = null;
		this.selector = null;
		this.action = null;
	}

	public dispatch(data: any = null, settings: any = null): void {
		if (settings && settings.delay) {
			DelayHelper.setTimeout(() => (this.action as Function)(data), settings.delay * 1000);
			return;
		}

		//Hit the callback straight away:
		(this.action as Function)(data);
	}

	public match(
		type: string,
		selector: SelectorElement = null,
		action: EventListenerOrEventListenerObject | Function = null
	): boolean {
		let listenerMatch: boolean = true;
		if (action && action !== this.action) {
			listenerMatch = false;
		}

		if (this.type === type && selector === this.selector && listenerMatch) {
			return true;
		}

		return false;
	}

	//Private methods
	//-------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------

	private _on(): void {
		if (this.selectorType === SelectorTypes.STRING) {
			(this, on(this.type, this.selector, this.action));
		} else if (this.selectorType === SelectorTypes.ELEMENT) {
			(this.selector as Element).addEventListener(this.type, this.action as EventListenerOrEventListenerObject, {
				passive: false
			});
		} else if (this.selectorType === SelectorTypes.NODE_LIST) {
			(this.selector as NodeListOf<Element>).forEach((item: Element) => {
				item.addEventListener(this.type, this.action as EventListenerOrEventListenerObject, { passive: false });
			});
		}
	}

	private _off(): void {
		if (this.selectorType === SelectorTypes.STRING) {
			off(this.type, this.selector, this.action);
		} else if (this.selectorType === SelectorTypes.ELEMENT) {
			//Cast: `passive` only exists on AddEventListenerOptions in lib.dom; the extra
			//member is simply ignored by removeEventListener at runtime:
			(this.selector as Element).removeEventListener(this.type, this.action as EventListenerOrEventListenerObject, {
				passive: false
			} as AddEventListenerOptions);
		} else if (this.selectorType === SelectorTypes.NODE_LIST) {
			(this.selector as NodeListOf<Element>).forEach((item: Element) => {
				item.removeEventListener(this.type, this.action as EventListenerOrEventListenerObject);
			});
		}
	}

	private _getSelectorType(selector: SelectorElement): SelectorTypes {
		if (typeof selector === 'string' || selector instanceof String) {
			return SelectorTypes.STRING;
		} else if (selector instanceof Element || selector instanceof Document || selector instanceof Window) {
			return SelectorTypes.ELEMENT;
		}

		return SelectorTypes.NODE_LIST;
	}
}
